import { useQuery } from '@tanstack/react-query';
import UpgradesService from '../../services/UpgradesService';

export const upgradeKeys = {
  all: ['upgrades'],
  list: () => [...upgradeKeys.all, 'list'],
};

export function useUpgrades() {
  return useQuery({
    queryKey: upgradeKeys.list(),
    queryFn: () => UpgradesService.listUpgrades('desc'),
  });
}
